import React, { ComponentProps, memo } from 'react'

import { Colors } from '@surglogs-app/ui.theme'

import { Box } from './Box'

interface ColorizeBounds {
  error: number
  warning: number
}

export const DEFAULT_COLORIZE_BOUNDS = {
  error: 20,
  warning: 80,
}

export const getProgressBarBackgroundColor = (
  percentage: number,
  colorize: boolean,
  colorizeBounds: ColorizeBounds,
): Colors => {
  if (!colorize) {
    return 'blue.100'
  }

  if (percentage <= colorizeBounds.error) {
    return 'red.100'
  }

  if (percentage <= colorizeBounds.warning) {
    return 'orange.100'
  }

  return 'green.100'
}

interface ProgressBarProps extends ComponentProps<typeof Box> {
  percentage: number
  colorize?: boolean
  colorizeBounds?: ColorizeBounds
}

export const ProgressBar = memo(
  ({
    percentage,
    colorize = false,
    colorizeBounds = DEFAULT_COLORIZE_BOUNDS,
    'aria-label': ariaLabel,
    ...rest
  }: ProgressBarProps) => (
    <Box
      {...{
        w: '100%',
        h: 'sm',
        bra: 'xs',
        bgc: 'blue.25',
        overflow: 'hidden',
        role: 'progressbar',
        'aria-valuemax': 100,
        'aria-valuemin': 0,
        'aria-label': ariaLabel ?? 'progressbar',
        ...rest,
      }}>
      <Box
        {...{
          h: '100%',
          bgc: getProgressBarBackgroundColor(
            percentage,
            colorize,
            colorizeBounds,
          ),
          w: `${percentage}%`,
        }}
      />
    </Box>
  ),
)
